import type { AxiosResponse } from 'axios';

import { API } from '@/api';
import { axiosInstance } from '@/utils/fetcher';

export interface ClaimTypeResponseItem {
  claimTypeKey: number;
  claimTypeDesc: string;
}

export const getClaimTypeAPI = () => {
  return axiosInstance.request({
    method: 'get',
    url: `${API.OVERCHARGE_CLAIM}/GetClaimType`,
  });
};

export type ClaimTypeResponse = ClaimTypeResponseItem[];

export const fetchClaimTypeList = async (): Promise<ClaimTypeResponse> => {
  const response: AxiosResponse<ClaimTypeResponse> = await getClaimTypeAPI();
  return response.data;
};
